module.exports = __webpack_public_path__ + "static/media/flag-KO.10651cd9.svg";